import styles from "@/pages/orderService/index.module.less";
import React from "react";
import {Tag} from "antd";
import { STags } from "shj-components";

export const getOrderStatusTag = (key: string) => {
  return <div>{ key ? <STags itemKey={key} /> : ''}</div>
}

export const getBizTypeTag = (key: string) => {
  return (
    <div>{ key ? <STags itemKey={key} /> : ''}</div>
  )
}